import { render, staticRenderFns } from "./SipaeeProfile.vue?vue&type=template&id=1e2cca95&scoped=true"
import script from "./SipaeeProfile.vue?vue&type=script&lang=js"
export * from "./SipaeeProfile.vue?vue&type=script&lang=js"
import style0 from "./SipaeeProfile.vue?vue&type=style&index=0&id=1e2cca95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2cca95",
  null
  
)

export default component.exports